/**
 * @Author: Yu Wang
 * @Date: 2019/3/26 16:37
 */
import loginConfig from './config'
import areas from './areas'
import Bridge from '../config/JSbridge.js'

// 获取网站协议和域名 返回如： https://kids.youdao.com
function getUrlPrefix() {
  const protocol = window.location.protocol || 'https:'
  const domain = '//' + (document.domain || 'kids.youdao.com')
  return protocol + domain
}

function merge(target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {}
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop]
        if (value !== undefined) {
          target[prop] = value
        }
      }
    }
  }

  return target
}

// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
function formatDate(time, fmt) {
  console.log(typeof time)
  switch (typeof time) {
    case 'string':
      time = new Date(time.replace(/-/g, '/'))
      break
    case 'number':
      time = new Date(time)
      break
    default:
      time = new Date(time)
      break
  }
  var o = {
    'M+': time.getMonth() + 1, //月份
    'd+': time.getDate(), //日
    'h+': time.getHours(), //小时
    'm+': time.getMinutes(), //分
    's+': time.getSeconds(), //秒
    'q+': Math.floor((time.getMonth() + 3) / 3), //季度
    S: time.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (time.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return fmt
}

function isIOS() {
  return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
}

function isAndroid() {
  return /(Android|Adr)/i.test(navigator.userAgent)
}

function isWeixin() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

function isAlipay() {
  return /Alipay/i.test(navigator.userAgent)
}

function isInNative() {
  console.log('native ua:' + navigator.userAgent)
  console.log('isInNative:' + /youdaokids/i.test(navigator.userAgent))
  return (
    /youdaokids/i.test(navigator.userAgent) ||
    /ydireading/i.test(navigator.userAgent)
  )
}

// 是否是有道天天读app
function isIreadingApp() {
  return /ydireading/i.test(navigator.userAgent)
}

function os() {
  let ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian && !isTablet
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc
  }
}

function arrayShuffle(arr) {
  var i = arr.length,
    t,
    j
  while (i) {
    j = Math.floor(Math.random() * i--)
    t = arr[i]
    arr[i] = arr[j]
    arr[j] = t
  }
  return arr
}

function setNativeTitle(title) {
  console.log('native app:' + isInNative())
  if (isInNative()) {
    console.log('call set native title')
    Bridge.callHandler('setAppTitle', {
      appTitle: title
    })
  }
}

function callAppLogin(
  next,
  firstChannel = null,
  skipParentVerification = false
) {
  Bridge.callHandler('appLogin', {
    next,
    firstChannel,
    skipParentVerification
  })
}

function callAppParentVerification(next) {
  Bridge.callHandler('appParentVerification', {
    next
  })
}

function compareVersion(v1, v2) {
  var _v1 = v1.split('.'),
    _v2 = v2.split('.'),
    _r = _v1[0] - _v2[0]
  return _r == 0 && v1 != v2
    ? compareVersion(_v1.splice(1).join('.'), _v2.splice(1).join('.'))
    : _r
}

function isAppOverVersion(appVersion = null, version) {
  if (!appVersion) {
    return false
  }
  let appVersionArr = appVersion.split('.')
  let shortCutVersion = appVersionArr[0] + '.' + appVersionArr[1]
  if (compareVersion(shortCutVersion, version) >= 0) {
    return true
  } else {
    return false
  }
}

function versionStringCompare(preVersion = '', lastVersion = '') {
  var sources = preVersion.split('.')
  var dests = lastVersion.split('.')
  var maxL = Math.max(sources.length, dests.length)
  var result = 0
  for (let i = 0; i < maxL; i++) {
    let preValue = sources.length > i ? sources[i] : 0
    let preNum = isNaN(Number(preValue))
      ? preValue.charCodeAt()
      : Number(preValue)
    let lastValue = dests.length > i ? dests[i] : 0
    let lastNum = isNaN(Number(lastValue))
      ? lastValue.charCodeAt()
      : Number(lastValue)
    if (preNum < lastNum) {
      result = -1
      break
    } else if (preNum > lastNum) {
      result = 1
      break
    }
  }
  return result
}

function filterEmojiInputHander(val) {
  if (val) {
    return String(val).replace(
      /[^\u4e00-\u9fa5_a-zA-Z0-9\s\·\~\！\@\#\￥\%\……\&\*\（\）\——\-\+\=\【\】\{\}\、\|\；\‘\’\：\“\”\《\》\？\，\。\、\`\~\!\#\$\%\^\&\*\(\)\_\[\]{\}\\\|\;\'\'\:\"\"\,\.\/\<\>\?]/gi,
      ''
    )
  }
  return val
}

function toMiniProgram(needVerify, miniProgramId, miniProgramPath) {
  Bridge.callHandler('toMiniProgram', {
    needVerify,
    miniProgramId,
    miniProgramPath
  })
}

function fissionShare(appTitle, snapBase64, pageType, category, outVender) {
  Bridge.callHandler('fissionShare', {
    appTitle,
    snapBase64,
    pageType,
    category,
    outVender
  })
}

function setAppShare(data) {
  Bridge.callHandler('setShareInfo', data)
}
function isPC() {
  return !/iPhone|Android|iPad/i.test(navigator.userAgent)
}
export function timeToString(param) {
  param = parseInt(param)
  let hh = '',
    mm = '',
    ss = ''
  if (param >= 0 && param < 60) {
    param < 10 ? (ss = '0' + param) : (ss = param)
    return '00:' + ss
  } else if (param >= 60 && param < 3600) {
    mm = parseInt(param / 60)
    mm < 10 ? (mm = '0' + mm) : mm
    param - parseInt(mm * 60) < 10
      ? (ss = '0' + String(param - parseInt(mm * 60)))
      : (ss = param - parseInt(mm * 60))
    return mm + ':' + ss
  } else {
    hh = parseInt(param / 3600)

    let leave = param - parseInt(hh * 3600)
    return hh + ':' + timeToString(leave)
  }
}
function isIreadingDomain() {
  return /ireading\.(.)*ydks.com/.test(document.domain)
}

function isPublishDomain() {
  return /publish\.(.)*youdao.com/.test(document.domain)
}
// 根据域名获取app协议
function getAppProtocol() {
  return isIreadingDomain() ? 'ydireading://' : 'kidseng://'
}

function getProductName() {
  return isIreadingDomain() ? '有道天天读' : '有道开口读'
}
const wxuuid = function () {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')
  return 'a-' + uuid
}

export default {
  loginConfig: loginConfig.loginConfig,
  areas: areas,
  merge,
  timeToString,
  isPC,
  getUrlPrefix,
  formatDate,
  isIOS,
  isAndroid,
  isWeixin,
  isAlipay,
  os,
  arrayShuffle,
  isInNative,
  setNativeTitle,
  callAppLogin,
  callAppParentVerification,
  filterEmojiInputHander,
  isAppOverVersion,
  toMiniProgram,
  fissionShare,
  setAppShare,
  isIreadingDomain,
  getAppProtocol,
  getProductName,
  versionStringCompare,
  isPublishDomain,
  wxuuid,
  isIreadingApp
}
